import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import {
    DO_NOTHING,
    FlyFreelyError,
    FlyFreelyLoggingService,
    PreferencesService
} from '@flyfreely-portal-ui/flyfreely';
import { Subject } from 'rxjs';
import { debounceTime, takeUntil } from 'rxjs/operators';

@Component({
    selector: 'data-privacy',
    templateUrl: './data-privacy.component.html',
    styleUrl: './data-privacy.component.scss'
})
export class DataPrivacyComponent implements OnInit, OnDestroy {
    form = new FormGroup({
        allowSentry: new FormControl(true),
        allowMixpanel: new FormControl(false)
    });

    private ngUnsubscribe$ = new Subject<void>();

    constructor(
        private preferencesService: PreferencesService,
        private logging: FlyFreelyLoggingService
    ) {
        this.preferencesService.userDataPrivacyOptions$
            .pipe(takeUntil(this.ngUnsubscribe$))
            .subscribe(options => {
                if (options != null) {
                    this.form.patchValue(options, { emitEvent: false });
                }
            });
    }

    ngOnInit() {
        this.form.valueChanges
            .pipe(debounceTime(500), takeUntil(this.ngUnsubscribe$))
            .subscribe(() => this.updateUserPrivacySettings());
    }

    ngOnDestroy() {
        this.ngUnsubscribe$.next();
        this.ngUnsubscribe$.complete();
    }

    updateUserPrivacySettings() {
        const options = this.form.value;
        this.preferencesService
            .setDataPreferences(
                options.allowSentry ?? false,
                options.allowMixpanel ?? false
            )
            .pipe(takeUntil(this.ngUnsubscribe$))
            .subscribe({
                next: DO_NOTHING,
                error: (error: FlyFreelyError) => {
                    this.logging.error(
                        error,
                        `Error while updating privacy settings: ${error.message}`
                    );
                }
            });
    }
}
